module.exports = __webpack_public_path__ + "static/media/YF47_7.4f51e80f.jpg";